import React from 'react';

const SUPPORT_EMAIL = 'support@mobile.digital';

const HelpCard: React.FC<{ keyword?: string; onContact?: () => void }> = ({ keyword, onContact }) => (
  <div className="bg-[#F5F8F1] rounded-2xl px-5 py-5 sm:px-6 flex flex-col sm:flex-row sm:items-center gap-4">
    <span className="w-10 h-10 rounded-full bg-white text-[#0A3B2C] flex items-center justify-center shrink-0">
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <circle cx="12" cy="12" r="9" />
        <path d="M9.1 9a3 3 0 015.8 1c0 2-3 2.5-3 4" />
        <path d="M12 17h.01" />
      </svg>
    </span>
    <div className="flex-1">
      <h3 className="text-base font-semibold text-gray-900">Need help?</h3>
      <p className="text-sm text-gray-600">
        If you're having trouble adding your pass, get in touch with our support team.
      </p>
    </div>
    <a
      href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(`Help adding wallet pass${keyword ? ` (${keyword})` : ''}`)}`}
      onClick={onContact}
      className="inline-flex items-center justify-center px-5 h-11 rounded-full bg-white border border-[#E4EAE2] text-sm font-semibold text-gray-900 hover:bg-gray-50 transition shrink-0"
    >
      Contact support
    </a>
  </div>
);

export default HelpCard;
